export default __webpack_public_path__ + "static/media/red-map-dot-viewed.788b164b.svg";